export const itemKey = (id: number, name?: string): string => `${id}:${name}`;
